'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import SchedulerLayout from './components/SchedulerLayout';

export default function SchedulerPage() {
  return (
    <AppLayout currentPath="/scheduler">
      <SchedulerLayout />
    </AppLayout>
  );
}
